/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TenantAdminsinviteTenantAdmin from './TenantAdminsinviteTenantAdmin';

/**
 * The TenantAdminsInviteBody model module.
 * @module model/TenantAdminsInviteBody
 * @version v0.3
 */
export default class TenantAdminsInviteBody {
  /**
   * Constructs a new <code>TenantAdminsInviteBody</code>.
   * @alias module:model/TenantAdminsInviteBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TenantAdminsInviteBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TenantAdminsInviteBody} obj Optional instance to populate.
   * @return {module:model/TenantAdminsInviteBody} The populated <code>TenantAdminsInviteBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TenantAdminsInviteBody();
      if (data.hasOwnProperty('tenant_admin'))
        obj.tenantAdmin = TenantAdminsinviteTenantAdmin.constructFromObject(data['tenant_admin']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TenantAdminsinviteTenantAdmin} tenantAdmin
 */
TenantAdminsInviteBody.prototype.tenantAdmin = undefined;

